namespace registration {

    declare var divisionsData: Division[]; // defined on Registration.cshtml
    interface Division {
        id: number;
        name: string;
        institutionId: number;
    }

    $(document).ready(() => {
        var formPasswordInputSelector = "form > .form-group.password-group";

        $("#registrationBox #aaf-radio-button").click(() => {
            $(formPasswordInputSelector).hide();
        });

        $("#registrationBox #checkapp-account-radio-button ").click(() => {
            $(formPasswordInputSelector).show();
        });

        $("#institutions").on('change', () => {
            let institutionId = <number>$("#institutions").val();
            if (!divisionsData) { // divisionsData should be defined on cshtml with all divisions comming from portal
                return;
            }
            let divisions = divisionsData.filter(o => o.institutionId == institutionId);
            $("#divisions").html("").append('<option value=""> - Please select - </option>');
            divisions.forEach(d => {
                $("#divisions").append(`<option value="${d.id}">${d.name}</option>`);
            });
        });

    });
}